import React, { Component } from "react";

import { Row, Col, Collapse, Select } from 'antd';
const { Option } = Select;

class FilterDropdown extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data : {
                name : "",
                placeholder : "",
                searchName : "",
                values : []
            },
            selectedValue : ""
        }
    }

    componentDidMount(){
        this.setState({ data: this.props.index });
    }

    componentWillReceiveProps(newProps){
        alert(JSON.stringify(newProps.searchData));
        
    }

    render(){

        let index = this.state.data;
        let optionList = [];        
        // alert(JSON.stringify(index))
        index.values.forEach( indexVal => {
            if(typeof indexVal === 'object' && indexVal !== null){
                optionList.push(<Option key={indexVal.value} value={indexVal.value} >{indexVal.label}</Option>);

            }else{
                optionList.push(<Option key={indexVal} value={indexVal} >{indexVal}</Option>);

            }
            
        });

        return (<Row type="flex" justify="center">
            <Col span={6}>{index.name}</Col>
            <Col span={18}>
                <Select
                    // allowClear
                    labelInValue
                    value={this.state.selectedValue}
                    // showSearch
                    style={{ width: '100%' }}
                    // placeholder={(index.placeholder != undefined && index.placeholder != null)?index.placeholder:"Select a "+index.name }
                    // optionFilterProp="children"
                    onChange={(selectedOption) => {
                        let val = null;
                        if(selectedOption !== undefined){
                            val = selectedOption.key;
                        }
                        this.setState({ "selectedValue" : val })
                        this.props.updateSearchData(index.searchName, val);
                    }}
                    // filterOption={(input, option) =>
                    //     option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    // }
                >
                    {optionList}
                </Select>
            </Col>
        </Row>);
    }

}

export default FilterDropdown;